import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';

export * from './Connections';
export * from './BigCommerce';
export * from './EasyStore';
export * from './Shopify';
export * from './Shopline';
export * from './Wix';


export function postConnectSources(successCallback, errorCallback, data, sourceId) {
  postAuth({
    "path": `sources/${sourceId}/connect`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postValidateSourcesListingUrl(successCallback, errorCallback, data, sourceId) {
  postAuth({
    "path": `sources/${sourceId}/validate-listing-url`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}
